export default "__VITE_ASSET__F7EIEv5p__"